import type { HseReportType } from '@felix/domain';
import { HSE_MENU_IDS, HseScreen, hseRoute } from '@felix/ui';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import { Shell } from '../components/Shell.js';
import { officeHseSource } from '../hse-source.js';

/**
 * Compliance ▸ HSEQ Reports (ADR 0049, ADR 0097; alt grup ADR 0097 Ek): ofiste filo listesi, kayıt, kapanışın ofis
 * adımı ve not. Rapor gemide yazılır. Türün eski yolu (`type`) listeyi o türle süzülü açar.
 */
export function HsePage({ type }: { type: HseReportType | null }) {
  const { t } = useTranslation();
  const { search } = useLocation();
  return (
    <Shell title={type ? t(`menu.${HSE_MENU_IDS[type]}`) : t('hse.hseq.title')}>
      <HseScreen
        key={type ?? 'all'}
        source={officeHseSource}
        type={type}
        route={hseRoute(search)}
      />
    </Shell>
  );
}
